import { Window } from './window';
import { Series } from './series';

export class Legend extends Window
{
    drawEllipsizedText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, maxWidth: number) {
        let metrics  = ctx.measureText(text);
        const width  = metrics.width;
        const height = metrics.actualBoundingBoxAscent;
        if (width <= maxWidth) {
            ctx.fillText(text, x, y + height / 2);
            return;
        }

        let len      = text.length;
        let ellipsis = '…';

        while (len > 0 && ctx.measureText(text.slice(0, len) + ellipsis).width > maxWidth) {
            len--;
        }
        ctx.fillText(text.slice(0, len) + ellipsis, x, y + height/2);
    }

    drawStars(ctx: CanvasRenderingContext2D, text: string, x: number, y: number) {
        ctx.font      = '11px Open Sans';
        let   metrics = ctx.measureText(text);
        const height  = metrics.actualBoundingBoxAscent;
        const spacing = 3;

        for (let i = 0; i < text.length; i++) {
            x += ctx.measureText(text[i]).width + spacing;

            ctx.setLineDash([]);
            ctx.strokeStyle = "black";
            ctx.lineWidth = 1.5;
            ctx.strokeText(text[i], x, y + height/2);

            ctx.fillStyle = "yellow";
            ctx.fillText(text[i], x, y + height / 2);
        }
    }

    draw(ctx : CanvasRenderingContext2D, series : Series[]) 
    {
        let y = this.cy + 20;

        ctx.fillStyle = '#F8F8F8'; // Set the fill color
        ctx.fillRect(this.cx, this.cy, this.cx + this.width, this.cy + this.height);

        for (const oneSeries of series) {
            if (oneSeries.accuracy !== undefined) {
                ctx.setLineDash([]);
                ctx.strokeStyle = "#C0C0C0";
                ctx.font        = '10px Open Sans';
                ctx.lineWidth   = 5;

                ctx.beginPath();
                ctx.moveTo(this.cx + 4, y);
                ctx.lineTo(this.cx + this.width - 4, y);
                ctx.stroke();

                ctx.setLineDash(oneSeries.dash);
                ctx.strokeStyle = oneSeries.color;
                ctx.font        = '10px Open Sans';
                ctx.lineWidth   = 5;

                ctx.beginPath();
                ctx.moveTo(this.cx + 4, y);
                ctx.lineTo(this.cx + 4 + (oneSeries.accuracy * (this.width - 8) / 1), y);
                ctx.stroke();
                y += 14;
            }

            ctx.setLineDash(oneSeries.dash);
            ctx.strokeStyle = oneSeries.color;
            ctx.font        = '10px Open Sans';
            ctx.fillStyle   = "black";
            ctx.lineWidth   = 2;

            ctx.beginPath();
            ctx.moveTo(this.cx + 4, y);
            ctx.lineTo(this.cx + 14, y);
            ctx.stroke();

            this.drawEllipsizedText(ctx, oneSeries.label, this.cx + 20, y, this.width - 20);
            y += 16;
            this.drawEllipsizedText(ctx, oneSeries.unit, this.cx + 20, y, this.width - 20);

            ctx.fillStyle = "#000000";
            let stars = "";
            for (let i = 0; i < oneSeries.rating; i++) {
                stars += "★";
            }
            this.drawStars(ctx, stars, this.cx + 110, y);
            y += 30;
        }
    }
}

